import {useFrame, useThree} from "@react-three/fiber";
import React, {useRef} from "react";
import * as THREE from "three";
import {MapState} from "../../../../Store/main/maps/@MapState.js";
import {observer_mgl_r3} from "../../../../Utils/ThreeJS/General.js";
import {Rect, Vec2} from "../../../../Utils/ThreeJS/VectorStructs.js";
import {mapZIndexes} from "./MapZIndexes.js";
import {BasicShape} from "./MapObjectUI.js";
import {ShapeType} from "../../../../Server/DB/mapObjects/@MapObject.js";
import {CreateAccessor} from "mobx-graphlink";
import {FocusLevel_NonBase} from "../../../../Store/main/maps/@MapState/MapSettings.js";

export const GetFocusL1Area_World = CreateAccessor((mapState: MapState, focusLevel: FocusLevel_NonBase): Rect|n=>{
	const focusArea_size = mapState.settings[`focusL${focusLevel}_size`] as Vec2|n;
	if (!focusArea_size) return null;
	const center = mapState.settings.general.focusL1_lockPos?.Cast(Vec2) ?? mapState.camPos_500ms.ToVec2();
	return Rect.FromCenter(center, focusArea_size.Cast(Vec2), true);
});

export const FocusAreaMarker = observer_mgl_r3((props: {mapState: MapState, focusLevel: FocusLevel_NonBase})=>{
	const {mapState, focusLevel} = props;
	const showFocusArea = mapState.settings[`focusL${focusLevel}_show`] as boolean|n;
	if (!showFocusArea) return null;
	const focusArea = mapState.settings[`focusL${focusLevel}_size`] as Vec2|n;
	if (!focusArea) return null;
	if (mapState.settings.general.screenshotMode) return null;
	const viewportCenter = mapState.settings.general.focusL1_lockPos?.Cast(Vec2).ToVec3() ?? mapState.camPos_0ms;

	return (
		<BasicShape localPos={viewportCenter.NewZ(mapZIndexes.objShape)} type={ShapeType.rectangle} size={focusArea} rounding={0} lineOnly={true} color="red"/>
	);
});